<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-file-plus-outline </v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-1 header_btn"
              >
                <v-icon size="28px"> mdi-clipboard-edit-outline </v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-7 header_btn">
                <v-icon size="28px"> mdi-eye-outline </v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-delete-outline </v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
            <v-btn icon dark class="ml-1 header_btn" disabled="">
                <v-icon size="28px">mdi-magnify</v-icon>
                <span class="lable_class">Search</span>
            </v-btn>
            <v-btn icon dark class="ml-7 header_btn" disabled="">
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
            </v-btn>
        </v-col>
        <v-col cols="1">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on"
              class="ml-1" @click="getSummary(true)">
                <v-icon size="28px"> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>Export report as excel</span>
          </v-tooltip> -->
            <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" class="header_btn" >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="28px" v-bind="attrs" v-on="on"> mdi-printer </v-icon>
                    <span class="lable_class">Export report</span>
                  </template>
                  <span>Export report</span>
                </v-tooltip>
              </v-btn>
            </template>
            <v-list>
              <v-list-item  @click="getSummaryExcel(true)">
                <v-list-item-title><v-icon size="30"> mdi-file-excel </v-icon>Generate report as Excel</v-list-item-title>
              </v-list-item>
              <v-list-item @click="getSummaryPdf(true)">
                <v-list-item-title> <v-icon size="30" > mdi-file-pdf </v-icon>Generate report as PDF</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="5" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Income's Customer
            <v-icon class="ml-2" size="30" style="color:#ffffff !important" @click="logout()" >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col cols="12">
          <router-link :to="'/report/4'" v-slot="{ href, navigate }">
            <a :href="href" @click="navigate">
              Report
            </a>
          </router-link>
          <span> / </span>
          <span>{{bank_name}}</span>
          <span class="ml-10" v-if="display_start_date && display_end_date">
            Date Range: <b>{{display_start_date}} - {{display_end_date}}</b>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          item-key="user_id"
          :search="search"
          :items="items.data"
          mobile-breakpoint="50"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td width="22%">{{ item.customer_name }}</td>
              <td width="12%">
                <div class="text-right">
                  <span
                    :class="{
                      'error--text': item.total < 0,
                      'primary--text': item.total > 0,
                    }"
                    >${{ parseFloat(getAmountFormat(item.total)).toFixed(2) }}
                  </span>
                </div>
              </td>
              <td width="4%">
                <v-btn
                  icon
                  style="height:unset;"
                  :to="redirectLink(item)"
                >
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </td>
              <td width="62%"></td>
            </tr>
          </template>

          <template v-slot:body.append>
            <tr class="grey lighten-1 fix-bottom-bar pr-3">
              <td width="34%" colspan="2" class="text-right">Total:
                <span
                    class="white--text"
                    :class="{
                      'error': total < 0,
                      'green': total > 0,
                    }"
                    >${{ parseFloat(getAmountFormat(total)).toFixed(2) }}
                  </span>
              </td>
              <td width="66%" colspan="2">
              </td>
            </tr>
          </template>

        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense="">
            <v-col cols="6" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">Rows per page: 
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense=""
                  hide-details=""
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-pagination
              class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="10"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getDateFilterValue,logout } from "../../plugins/helper";
import { mapState } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      loading: false,
      search:'',
      items: {
        data: [],
      },
      bank_name:'',
      display_start_date: getDateFilterValue('display_start_date'),
      display_end_date: getDateFilterValue('display_end_date'),
      total: 0,
      headers: [
        { value: "name", text: "Name", sortable: false, width: "22%" },
        { value: "value", text: "Income", sortable: false, align: "right", width: "12%"},
        { value: "", text: "", sortable: false, width: "4%" },
        { value: "", text: "", sortable: false, width: "62%" },
      ],
      pagination: {
        itemsPerPage: -1,
        sortBy: [],
        page: 1,
        filters: {
          filter_by: 1,
          tran_start_date: getDateFilterValue('start_date'),
          tran_end_date: getDateFilterValue('end_date'),
          date_filter: getDateFilterValue('date_filter'),
          bank_id: this.$route.params.bank_id
        },
      },
    };
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
  },
  watch: {
    pagination: {
      handler: function () {
        this.getSummary(false);
      },
      deep: true,
    },
  },
  methods: {
    redirectLink(item) {
      return '/report_income/'+this.$route.params.bank_id+'/'+item.customer_id
    },
    getAmountFormat(value) {
      if(value) {
        value = value.toString();
        return value.replace("-", "");
      } else {
        return 0
      }
    },
    getSummaryPdf(){
      let company_data = localStorage.getItem('company_data')
      company_data = JSON.parse(company_data)
      let url = parseParams(this.pageData);
      url = url+'&itemsPerPage=-1';
      window.location.href = process.env.VUE_APP_BASEURL+'/generate_get_profit_loss_data_customer_pdf?is_pdf=true&income_customer=true&user_id='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&'+url;
    },
     getSummaryExcel(){
      let company_data = localStorage.getItem('company_data')
      company_data = JSON.parse(company_data)
      let url = parseParams(this.pageData);
      url = url+'&itemsPerPage=-1';
      window.location.href = process.env.VUE_APP_BASEURL+'/generate_get_profit_loss_data_customer_pdf?is_pdf=true&is_excel=true&income_customer=true&user_id='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&'+url;
    },
    getSummary(isGenerateReport) {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      if(isGenerateReport) {
        url = url+'&itemsPerPage=-1';
      }
      axios.get("get_profit_loss_view_data?" + url)
        .then((response) => {
          if(isGenerateReport) {
            var csv = 'Name,Income\n';
            response.data.data.data.forEach(function(item) {  
              let name = item.customer_name;
              let total = (item.total)?'$'+item.total:'';
              csv += name+','+total+"\n";
            });
            csv += 'Total,$'+response.data.total+'\n';
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'income_customer.csv'
            hiddenElement.click()
          } else {
            if (_self.items.total != response.data.data.total) {
              _self.pagination.page = 1;
            }
            _self.items = response.data.data;
            _self.total = response.data.total;
            _self.bank_name = response.data.bank_name;
          }
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    localStorage.removeItem('is_report_from_dashboard');
  },
};
</script>
<style>

</style>